import { sendAPIRequest } from "shared/utils/requests";

export const UPDATE_ONBOARDING_STEP = "UPDATE_ONBOARDING_STEP";
export const UPDATE_TRANSCRIPTION_TEST = "UPDATE_TRANSCRIPTION_TEST";

export const updateOnboardingStep = (onboardingStep) => (
    {
        type: UPDATE_ONBOARDING_STEP,
        onboardingStep,
    }
);

export const updateTranscriptionTest = (transcriptionTest) => (
    {
        type: UPDATE_TRANSCRIPTION_TEST,
        transcriptionTest,
    }
);